import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SydSelect from '../../../../../commonDesign/SydSelect'

// Compact select that the allocation tool registers into the panel
// toolbar's `actions` slot. Lets the user switch the chart's measure
// without re-fetching (the request includes all currency columns).
export default function MeasurePicker ({ measureOptions, value, onChange }) {
  const options = useMemo(
    () => measureOptions.map(opt => ({ value: opt.id, label: opt.label })),
    [measureOptions]
  )

  return (
    <SydSelect
      options={options}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      size='xs'
      minWidth='160px'
    />
  )
}

MeasurePicker.propTypes = {
  measureOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
}
